export default '/Users/pouya/Projects/clio/node_modules/source-map/lib'